import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AvatarProvider {

    public avatarMap: Map<string | number, string> = new Map<string | number, string>();

    constructor(private http: HttpClient) { }

    public httpOptions = {
        headers: new HttpHeaders(
            { 'Content-Type': 'text/plain' }
        ),
        responseType: "text" as "json",
        withCredentials: true
    }
}